<template>
  <div class="edit">
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-text-field
          v-model="url"
          :counter="256"
          :rules="urlRules"
          label="URL"
          required
          clearable
        ></v-text-field>
        <div v-if="error" class="red--text">
          <p>ERROR: Can't set this URL!</p>
          <p class="ml-2">{{ error }}</p>
        </div>
      </v-form>
      <p v-if="this.acceptOKresponse" class="green--text font-weight-medium">
        URL is registered successfully!
      </p>
      <!-- difference
      <v-btn v-if="this.acceptOKresponse" :href="'https://ml.uedasoft.com/ml/' + $externalID"> -->
<!--          <v-btn v-if="this.acceptOKresponse" :href="'https://ml.uedasoft.com/ml/' + this.$route.params.externalID"> -->
      <v-btn 
        v-if="this.acceptOKresponse" :href="'https://ml.uedasoft.com/ml/' + this.externalID"
        text
        x-small
      >
        Test reading
      </v-btn>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        dark
        rounded
        color="primary"
        @click="registerURL"
      >
<!--      <v-icon>cloud_upload</v-icon> -->
        register
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
// @ is an alias to /src
//import axios from 'axios';
//import QRCode from 'qrcode';
export default {
  props: ['externalID', 'getIdToken'],
  data: () => ({
    error: "",
    valid: true,
    url: '',
    urlRules: [
      v => !!v || 'URL is required',
      v => (v && v.length <= 256) || 'URL must be less than 256 characters',
      /* eslint no-useless-escape: 0 */
      v => /https?:.*/.test(v) || 'URL should start with "http:" or "https:"',
      v => /https?:[0-9]*\/\/.*/.test(v) || 'URL should include "//"',
//      v => /https?:[0-9]*\/\/[\w!?/\+\-_~=;\.,*&@#$%\(\)\'\[\]]+/.test(v) || 'URL must be valid',
    ],
    response: "",
    acceptOKresponse: false,
  }),
  watch: {
    url: function(newurl, oldurl){
      console.log(newurl, oldurl);
      this.acceptOKresponse = false;
      this.error = ""
    }
  },
  components: {
  },
  methods:{
    registerURL: async function() {
      // https://github.com/axios/axios#using-applicationx-www-form-urlencoded-format
//      const params = new URLSearchParams();
// different       
//      params.append('id', this.$externalID);
//      params.append('id', this.$route.params.externalID);
//      params.append('id', this.externalID);
//      params.append('url',this.url);
      let updateRedirectURLParam
      if (this.getIdToken == null) {
        updateRedirectURLParam = {"id": this.externalID, "url": this.url}
      } else {
        const idToken = await this.getIdToken()
        updateRedirectURLParam = {"id": this.externalID, "url": this.url, "IDToken": idToken}
      }
      const res = await fetch('https://ml.uedasoft.com/v1/updateRedirectURL', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateRedirectURLParam)
      })
      if (res.status == 200) {
        this.acceptOKresponse = true;
      } else {
        console.log(res)
        this.error = await res.text();
      }

      // go back to demo if demo
      /*global demo*/
      if (demo) {
        console.log("externalID", this.externalID)
        location.href="https://ml.uedasoft.com/demo/" + this.externalID
      }
/*
      axios
        .post('https://ml.uedasoft.com/v1/updateRedirectURL', params)
        .then(response => {
          this.response = response;
          console.log(response);
          if (response.data.update == "ok") {
            this.acceptOKresponse = true;
          }
        })
*/
    },
  },
  mounted: function(){
  }
}
</script>